import { schema } from "normalizr";
import { Transaction as TransactionRecord } from "records/payments";

export const Transaction = new schema.Entity(
    "transaction",
    {},
    {
        idAttribute: "id",
    }
);

(Transaction as any).record = TransactionRecord;
